import styled from 'styled-components'

import { FlatButton, LinkButton as LinkButtonUnstyled } from 'components/Button'
import IndexLayoutUnstyled, {
  Main as IndexLayoutWrapper,
} from 'components/IndexLayout'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Text = styled.div`
  display: flex;
  justify-content: center;
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  font-size: ${({ theme }) => theme.fontSizes.small};
  margin-bottom: 8px;
`

export const StyledLinkButton = styled(FlatButton)`
  padding: 0;
  text-decoration: underline;
  line-height: 1.4;
  cursor: pointer;
`

export const IndexLayout = styled(IndexLayoutUnstyled)`
  ${IndexLayoutWrapper} {
    margin-top: auto;
  }
`

export const DoThisLaterButton = styled(LinkButtonUnstyled)`
  min-width: 240px;
  margin: 48px auto;
`
